import {
  BallotCheckIcon,
  BestValueCard,
  CircleDollarIcon,
  CrownIcon,
  TitleDuoTone,
} from '@fff-web/fff-ui-shared';
import * as styles from './AnnualMemberContainer.module.scss';

const BADGE_TEXT = 'LIMITED TIME - $50/BOX';
const CARD_TITLE = 'Upgrade to Annual';
const PROMOTION_PRICE = '$150';
const BOXES_AMOUNT = '/ 3 boxes';
const PROMOTION_PRICE_ID = 'promotion-price';

const title = {
  text: 'Annual Members Save Over $1,702* a Year',
  textToChangeColor: '$1,702',
  color: '#fb6a66',
};

const perks = [
  {
    icon: <CircleDollarIcon />,
    text: (
      <p>
        <strong>Box Discounts.</strong> $20 off your next 3 boxes ($60 savings each year!)
      </p>
    ),
  },
  {
    icon: <BallotCheckIcon />,
    text: (
      <p>
        <strong>Max Choice. </strong> Early access to box customization to snag your faves
      </p>
    ),
  },
  {
    icon: <CrownIcon />,
    text: (
      <p>
        <strong>VIP Treatment. </strong> Exclusive access to our biggest sale events
      </p>
    ),
  },
];

const annualPriceCopy = (annualPrice) =>
  annualPrice && `Annual Memberships automatically renew for $${annualPrice} for 4 boxes/year.`;

const AnnualMemberContainer = ({ annualPrice }) => {
  const { text, textToChangeColor } = title;

  return (
    <section className={styles.wrapper}>
      <TitleDuoTone text={text} textToChangeColor={textToChangeColor} />
      <div className={styles.wrapperList}>
        <ul className={styles.wrapperList}>
          {perks.map((perk, index) => (
            <li key={`${index}-${perk.text}`}>
              <span>{perk.icon}</span>
              {perk.text}
            </li>
          ))}
        </ul>
      </div>
      <BestValueCard badge={BADGE_TEXT} className={styles.customBestCarStyles} size="large">
        <div className={styles.cardContent}>
          <h2>{CARD_TITLE}</h2>
          <h2 data-testid={PROMOTION_PRICE_ID}>
            {PROMOTION_PRICE}
            <span>{BOXES_AMOUNT}</span>
          </h2>
          <p>{annualPriceCopy(annualPrice)}</p>
        </div>
      </BestValueCard>
    </section>
  );
};

export {
  AnnualMemberContainer,
  BADGE_TEXT,
  CARD_TITLE,
  PROMOTION_PRICE,
  BOXES_AMOUNT,
  annualPriceCopy,
  PROMOTION_PRICE_ID,
};
